import Vue, { VueConstructor } from 'vue';

const svgCache = new Map<string, Promise<string>>();

const createCachedVueComponent = (svgPath: string): VueConstructor => {
    if (!svgCache.has(svgPath)) {
        const fetchPromise = fetch(svgPath)
            .then(r => r.text())
            .catch(error => {
                svgCache.delete(svgPath);
                return '';
            });
        svgCache.set(svgPath, fetchPromise);
    }

    return Vue.extend({
        data: () => ({
            svg: '',
        }),
        async created() {
            const cachedPromise = svgCache.get(svgPath);
            if (cachedPromise) {
                this.svg = await cachedPromise;
            }
        },
        template: '<g v-html="svg"></g>',
    });
};

export default (svgPath: string): VueConstructor => createCachedVueComponent(svgPath);
